function preloadResources(resourceList, progressCallback) {
  const totalResources = resourceList.length;
  let loadedResources = 0;
  return new Promise((resolve, reject) => {
      function resourceLoaded() {
      loadedResources++;
      progressCallback(loadedResources / totalResources);
      if (loadedResources === totalResources) {
          setTimeout(() => {
              resolve();
              }, 600);
          }
      }
      resourceList.forEach((resource) => {
      const isImage = /\.(jpeg|jpg|png|gif)$/.test(resource);
      const isVideo = /\.(mp4|webm|ogg)$/.test(resource);
      const isFont = /\.(woff|woff2|eot|ttf|otf)$/.test(resource);
      if (isImage) {
          const image = new Image();
          image.onload = resourceLoaded;
          image.onerror = reject;
          image.src = resource;
      } else if (isVideo) {
          const video = document.createElement("video");
          video.oncanplaythrough = resourceLoaded;
          video.onerror = reject;
          video.src = resource;
          video.load();
      } else if (isFont) {
          const fileName = resource.match(/[^/]+(?=\.)/)[0];
          const font = new FontFace(fileName, `url(${resource})`);
          document.fonts.add(font);
          font.load().then(resourceLoaded, reject);
      } else {
          reject();
      }
      });
  })
}

export { preloadResources };
